import React from 'react';
import { t } from 'Src/i18n';
import { TextSeeMore } from 'Components/frameworks/text-see-more/TextSeeMore';
import { Title } from 'Components/frameworks/title/Title';
type Props = {
  className?: string;
  text: string | null | undefined;
  title: string | null | undefined;
};
export const InformationCard = ({ className, text, title }: Props) => {
  if (!title || !text) {
    return null;
  }

  return (
    <article className={className}>
      <Title className="mb-10" theme="title-brand-n3">
        {title}
      </Title>
      <TextSeeMore
        text={text}
        dataTestIdPrefix="InformationCard"
        hasNoScrollOnCollapse
        seeLessLabel={t('common.close')}
        seeMoreLabel={t('common.viewMore')}
        seeMoreSize={150}
      />
    </article>
  );
};
